import { render, staticRenderFns } from "./ViewProposal.vue?vue&type=template&id=298d74d7&"
import script from "./ViewProposal.vue?vue&type=script&lang=js&"
export * from "./ViewProposal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports